import { schema } from 'normalizr';
import apiResourceBuilder from '../../../../common/utils/apiResourceBuilder';
import entityActionCreator from '../../../../common/utils/entityActionCreator';

export const organizationApi = apiResourceBuilder({
  name: 'organization',
  idResolver: ({ key }) => key,
});

export const OrganizationSchema = new schema.Entity(
  'organizations',
  {},
  { idAttribute: 'key' }
);
export default entityActionCreator({
  schema: OrganizationSchema,
  api: organizationApi,
});



// WEBPACK FOOTER //
// ./src/App/account/actions/organizations/index.js